import React from 'react'

function AddExclusionDate({ newExclusionDate, setNewExclusionDate, exclusionError, handleAddExclusion }) {
  return (
    <div className="modal-content-custom">
        <label className="form-label">Select Date to Exclude</label>
        <input 
            style={{ display: 'block' , color: 'black', background: 'white', border: '1px solid black', borderRadius: '5px'}}
            type="date" 
            className="form-control"
            onChange={(e) => setNewExclusionDate(new Date(e.target.value))}
            value={newExclusionDate?.toISOString().split('T')[0]}
        />
        {exclusionError && <div className="error-message mt-2">{exclusionError}</div>}
        <button 
            className="btn-save btn-exclude mt-2"
            onClick={handleAddExclusion}
        >
            Add Exclusion
        </button>
    </div>
  )
}

export default AddExclusionDate
